import { render, staticRenderFns } from "./StaffPositionSetup.vue?vue&type=template&id=8665f2fe&"
import script from "./StaffPositionSetup.vue?vue&type=script&lang=js&"
export * from "./StaffPositionSetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports